import { useLocalStorage } from '@vueuse/core'
import { readonly } from 'vue'
import { useTolgee } from '@tolgee/vue'
import { buildDropeeStorageKey } from '@/config/config'

export const supportedLanguages = ['en', 'fr']

// const selectedLanguage = useLocalStorage('i18n.lang', supportedLanguages.includes(webapp.language) ? webapp.language : 'en')
const selectedLanguage = useLocalStorage(buildDropeeStorageKey('i18n.lang'), 'en')

export const useI18n = () => {
  const tolgee = useTolgee(['language'])

  return {
    selectedLanguage: readonly(selectedLanguage),
    changeLanguage: async (language: string) => {
      await tolgee.value.changeLanguage(language)
      selectedLanguage.value = language
    },
  }
}

export async function useInitI18n(tolgee: ReturnType<typeof useTolgee>) {
  await tolgee.value.changeLanguage(selectedLanguage.value)
}
